import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.thirdSection;

export default [
  {
    title: 'PVE',
    info: '战舰战',
    mapIcon: require('./images/thumbnail1.png'),
    characteristicImgs: require('./images/mecha1.jpg'),
    ...textInfo[0]
  },
  {
    title: '战利品',
    info: '占位',
    mapIcon: require('./images/thumbnail1.png'),
    characteristicImgs: require('./images/mecha2.jpg'),
    ...textInfo[1]
  },
  {
    title: '撤离',
    info: '占位',
    mapIcon: require('./images/thumbnail1.png'),
    characteristicImgs: require('./images/mecha3.jpg'),
    ...textInfo[2]
  },
  {
    title: '使命',
    info: '占位',
    mapIcon: require('./images/thumbnail1.png'),
    characteristicImgs: require('./images/mecha4.jpg'),
    ...textInfo[3]
  },
  {
    title: '自定义武装',
    info: '占位',
    mapIcon: require('./images/thumbnail1.png'),
    characteristicImgs: require('./images/mecha5.jpg'),
    ...textInfo[4]
  },
  {
    title: '超大战场',
    info: '占位',
    mapIcon: require('./images/thumbnail1.png'),
    characteristicImgs: require('./images/mecha6.jpg'),
    ...textInfo[5]
  }
];
